import AppDownloadCard from "modules/referral/AppDownloadCard";

export default function DownloadApplication () {

  return <AppDownloadCard />
}